import { combineReducers } from 'redux';
import {
  UPDATE_DEPLOYMENT,
  SET_DEPLOYMENTS,
  SET_HEARTBEATS,
  SET_DEPLOYMENT_CONFIG,
  SET_DEPLOYMENT_MODBUS,
  SET_DEPLOYMENT_DISCOVERY,
} from '../actions/actiontypes';
import { groupByProperty } from '../../utils/collections';

const deployments = (state = {}, action) => {
  if (action.type === SET_DEPLOYMENTS) {
    const deps = action.data.slice();
    return groupByProperty('id', deps);
  }
  if (action.type === UPDATE_DEPLOYMENT) {
    const newState = [...state];
    newState[action.data.id] = action.data;
    return newState;
  }
  return state;
};

const configs = (state = {}, action) => {
  if (action.type !== SET_DEPLOYMENT_CONFIG) return state;
  return {
    ...state,
    [action.data.site]: action.data,
  };
};

const modbus = (state = {}, action) => {
  if (action.type !== SET_DEPLOYMENT_MODBUS) return state;
  return {
    ...state,
    [action.site]: action.data.map((m) => ({ ...m, buildingId: m.building_id })),
  };
};

const discovery = (state = {}, action) => {
  if (action.type !== SET_DEPLOYMENT_DISCOVERY) return state;
  return {
    ...state,
    [action.site]: action.data,
  };
};

const heartbeats = (state = {}, action) => {
  if (action.type !== SET_HEARTBEATS) return state;
  const newState = { ...state };
  newState[action.data.site] = action.data.heartbeats;
  return newState;
};

const latestHeartbeats = (state = {}, action) => {
  if (action.type !== SET_HEARTBEATS) return state;
  const newState = { ...state };
  newState[action.data.site] = action.data.heartbeats.reduce((o, hb) => {
    const { timestamp } = hb;
    if (o == null || timestamp > o.timestamp) {
      // eslint-disable-next-line no-param-reassign
      o = hb;
    }
    return o;
  }, null);
  return newState;
};

const deploymentsReducer = combineReducers({
  deployments,
  configs,
  modbus,
  discovery,
  heartbeats,
  latestHeartbeats,
});

export default deploymentsReducer;
